import React, { useCallback, useState, useEffect } from "react";
import {
  Box,
  Fade,
  FormControl,
  InputLabel,
  Modal,
  TextField,
  Typography,
} from "@material-ui/core";
import { ReactComponent as CircleLeft } from "../../../../assets/icons/circle-left.svg";
import { ReactComponent as CircleRight } from "../../../../assets/icons/circle-right.svg";
import "./index.scss";
import { trackPromise } from "react-promise-tracker";
import {
  buscarProdutoOportunidade,
  detalheOportunidade,
  listarCdsOportunidadeSeller,
} from "../../../../services/http/oportunidadeService";
import { useSnackBar } from "../../../../hooks/snackBar";
import { convertTextUnitToNumber } from "../../../../util/NumberConvert";
import logoCompany from "../../../../assets/img/LogoGreeners.jpg";
import globals from "../../../../globals";

const LINK_PORTAL = globals.REACT_APP_URL_BASE_FRONT_PORTAL;

function ResumoOportunidade({ showModal, handleCloseModal, data }) {
  const [position, setPosition] = useState(0);
  const [gotProductDetails, setGotProductDetails] = useState(true);
  const { addSnackBar } = useSnackBar();
  const [values, setValues] = useState({
    codigo: "",
    detalheLoteDto: [
      {
        urlImagens: "",
        gtinEan: "",
        descricao: "",
        marca: "",
        dataValidade: "",
        tipoFrete: "",
        ncm: "",
        gtinDun14Caixa: "",
        motivoOferta: "",
        precoCaixa: "",
        quantidadePorCaixa: "",
        estoqueDisponivelCaixas: "",
        pedidoMinimo: "",
        precoUnidade: 0.0,
        feeGreenersPrecoMedioVarejo: "",
        precoUnitarioFee: 0,
        valorEconomia: 0,
        markup: 0,

        localizacaoCarga: [
          {
            cidade: "",
            estado: "",
            quantidade: "",
          },
        ],
      },
    ],
  });

  const nextIsValid = useCallback(
    () => position < values?.detalheLoteDto.length - 1,
    [position, values?.detalheLoteDto.length]
  );

  const previousIsValid = useCallback(() => position > 0, [position]);

  const handleGoToNextProduct = useCallback(() => {
    if (nextIsValid()) {
      setPosition((old) => old + 1);
      buscarOportunidade(data?.id);
    }
  }, [nextIsValid]);

  const handleGoToPreviousProduct = useCallback(() => {
    if (previousIsValid()) {
      setPosition((old) => old - 1);
      buscarOportunidade(data?.id);
    }
  }, [previousIsValid]);

  const handleConvertToCurrencyText = useCallback((value) => {
    const numberWithDecimals = Number(value || 0).toFixed(2);
    return Number(numberWithDecimals).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }, []);

  const buscarOportunidade = (oportunidadeId) => {
    trackPromise(
      detalheOportunidade(oportunidadeId).then(async (res) => {
        if (res.fail) {
          throw new Error(res.errors);
        }

        const _values = {
          ...res.data,
          detalheLoteDto: res.data?.detalheLoteDto,
        };

        setValues(_values);
        setGotProductDetails(false);
      })
    ).catch((error) => {
      addSnackBar({
        message: "Não foi possível encontrar a oportunidade.",
        info: "error",
        open: true,
      });
      console.log(error);
    });
  };

  const buscarDetalheProdutos = async () => {
    const product_promises = [];
    const _values = { ...values };

    const { data: locations } = await listarCdsOportunidadeSeller(
      values.dadosEmpresaSellerId
    );

    _values.detalheLoteDto.forEach((detalheLote, index) => {
      if (detalheLote.gtinEan) {
        product_promises.push(
          buscarProdutoOportunidade(
            values.dadosEmpresaSellerId,
            detalheLote.gtinEan
          )
        );
      }
    });

    Promise.all(product_promises)
      .then((list) => {
        list.forEach(({ data }) => {
          const index = _values.detalheLoteDto.findIndex(
            (item) => item.gtinEan === data.gtin
          );

          if (index < 0) return;

          const precoUnidade =
            _values.detalheLoteDto[index].precoVenda_NF_PorCaixa /
              convertTextUnitToNumber(data.quantidadePorCaixa) || 0;

          const economy = !!_values.detalheLoteDto[index]
            .feeGreenersPrecoMedioVarejo
            ? Math.max(
                0,
                Number(
                  _values.detalheLoteDto[index].feeGreenersPrecoMedioVarejo
                )
              ) -
              _values.detalheLoteDto[index].precoVenda_NF_PorCaixa /
                convertTextUnitToNumber(data.quantidadePorCaixa)
            : 0;

          const handleCalculateUnitPriceFee = (lote) => {
            return Math.max(0, lote.precoCaixa / lote.quantidadePorCaixa);
          };

          const maximomarkup = !!_values.detalheLoteDto[index]
            .feeGreenersPrecoMedioVarejo
            ? Number(
                Math.max(
                  0,
                  Number(
                    _values.detalheLoteDto[index].feeGreenersPrecoMedioVarejo
                  ) /
                    handleCalculateUnitPriceFee(_values.detalheLoteDto[index]) -
                    1
                ).toFixed(2)
              )
            : 0;

          _values.detalheLoteDto[index]?.localizacaoCarga?.map((location) => {
            const locationDetails = locations.find(
              (item) => item.id === location.id
            );
            if (locationDetails) {
              return {
                ...location,
                cidade: locationDetails.cidade,
                estado: locationDetails.estado,
              };
            }
            return location;
          });

          _values.detalheLoteDto[index] = {
            ..._values.detalheLoteDto[index],
            ...data,
            //precoUnidade: precoUnidade,
            //valorEconomia: economy,
            markupPorUnidade: maximomarkup,
            feeGreenersPrecoMedioVarejo: Number(
              _values.detalheLoteDto[index].feeGreenersPrecoMedioVarejo
            ),
          };
        });
      })
      .finally(() => {
        setValues(_values);
        setGotProductDetails(true);
      });
  };

  useEffect(() => {
    if (data?.id) {
      buscarOportunidade(data?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (!gotProductDetails) {
      buscarDetalheProdutos();
    }
  }, [gotProductDetails]);

  return (
    <Modal className="modal-sizeOp" open={showModal} close={handleCloseModal}>
      <div className={"modal-contentOp defaultFont"}>
        {/* <Fade style={{ transitionDuration: 1000 }} in={true}> */}
          <div style={{ width: "100%" }}>
            <div className="row topoOportunidade">
            <div className="col-md-12 p-0 d-flex justify-content-between align-items-center   mb20" >
              <div className="tituloOportunidade" style={{ margin: 0 }}>
                Resumo da oportunidade
              </div>
              <div className="modal-header">
                <div
                  title="Clique para visualizar a oportunidade anterior."
                  onClick={handleGoToPreviousProduct}
                 disabled={!previousIsValid()}
                >
                  <svg
                    className="setaAvancarVoltar"
                    viewBox="0 0 34.386 34.487" 
                    style={{rotate:"180deg"}}
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_2684"
                          data-name="Retângulo 2684"
                          width="34.386"
                          height="34.487"
                          fill={!previousIsValid() ? "#aaa" : "#5ea845"}
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_4906"
                      data-name="Grupo 4906"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Caminho_6411"
                        data-name="Caminho 6411"
                        d="M17.189,0a17.223,17.223,0,0,1,17.2,17.189,17.435,17.435,0,0,1-5.048,12.25,17.137,17.137,0,0,1-24.293,0A17.431,17.431,0,0,1,0,17.189,17.217,17.217,0,0,1,17.189,0M15.134,9.984l7.1,7.1a.194.194,0,0,1,0,.309l-7.1,7.1c0,.1-.211.1-.211,0l-1.645-1.543,5.557-5.56a.187.187,0,0,0,0-.309l-5.557-5.56,1.645-1.543c0-.1.211-.1.211,0"
                        transform="translate(0 0)"
                        fill={!previousIsValid() ? "#aaa" : "#5ea845"}
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </div>
                <div
                  title="Clique para visualizar a próxima oportunidade."
                  onClick={handleGoToNextProduct}
                  disabled={!nextIsValid()}
                >
                  <svg
                    className="setaAvancarVoltar"
                    viewBox="0 0 34.386 34.487"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Retângulo_2684"
                          data-name="Retângulo 2684"
                          width="34.386"
                          height="34.487"
                          fill={!nextIsValid() ? "#aaa" : "#5ea845"}
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Grupo_4906"
                      data-name="Grupo 4906"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Caminho_6411"
                        data-name="Caminho 6411"
                        d="M17.189,0a17.223,17.223,0,0,1,17.2,17.189,17.435,17.435,0,0,1-5.048,12.25,17.137,17.137,0,0,1-24.293,0A17.431,17.431,0,0,1,0,17.189,17.217,17.217,0,0,1,17.189,0M15.134,9.984l7.1,7.1a.194.194,0,0,1,0,.309l-7.1,7.1c0,.1-.211.1-.211,0l-1.645-1.543,5.557-5.56a.187.187,0,0,0,0-.309l-5.557-5.56,1.645-1.543c0-.1.211-.1.211,0"
                        transform="translate(0 0)"
                        fill={!nextIsValid() ? "#aaa" : "#5ea845"}
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            </div>
            <div className="row mb-3" >
              <div className="col-sm-12 col-md-12 col-lg-12 p-0">
                <div className="infoOportunidade">ID da Oportunidade:</div>

                <div className="textoOportunidade">
                  #{values?.codigo.toString().padStart(6, "0")}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 summary-image-container mt-2">
                <img
                  alt={values?.detalheLoteDto[position]?.descricao}
                  src={values?.detalheLoteDto[position]?.urlImagens}
                  className="summary-product-image"
                />
              </div>
              <div className="col-md-9">
                <div className="row">
                <div className="col-sm-8 col-md-8 col-lg-8">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Descrição Curta"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.descricao}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Preço por Caixa"
                        size="small"
                        inputProps={{ readOnly: true }}
                        className="summary-field-green-oportunidades"
                        value={handleConvertToCurrencyText(
                          values?.detalheLoteDto[position]?.precoCaixa
                        )}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Preço Unitário"
                        size="small"
                        className="summary-field-green-oportunidades"
                        inputProps={{ readOnly: true }}
                        value={handleConvertToCurrencyText(
                          values?.detalheLoteDto[position]?.precoUnitarioFee
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Preço Médio Varejo (Unidade)"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={handleConvertToCurrencyText(
                          values?.detalheLoteDto[position]
                            ?.feeGreenersPrecoMedioVarejo
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl className="ean-input">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="EAN"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.gtinEan}
                      />
                    </FormControl>
                  </div>

                </div>
                <div className="row">
          
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Estoque Disponível (Caixas)"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={
                          values?.detalheLoteDto[position]
                            ?.estoqueDisponivelCaixas
                        }
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Quantidade por Caixa"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={
                          values?.detalheLoteDto[position]?.quantidadePorCaixa
                        }
                      />
                    </FormControl>
                  </div>    
                       
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Marca"
                        size="small"
                        inputProps={{ readOnly: true }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values?.detalheLoteDto[position]?.marca}
                      />
                    </FormControl>
                  </div>             
                </div>
                
                <div className="row">
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Validade"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.dataValidade}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Tipo de Frete"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.tipoFrete}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="NCM"
                        size="small"
                        inputProps={{ readOnly: true }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values?.detalheLoteDto[position]?.ncm}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row">
           
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="GTIN/DUN"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.gtinDun14Caixa}
                      />
                    </FormControl>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Motivo da Oferta"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.motivoOferta}
                      />
                    </FormControl>
                  </div>
                  </div>
                {values?.detalheLoteDto[position]?.localizacaoCarga &&
                  values?.detalheLoteDto[position]?.localizacaoCarga.map(
                    (local) => (
                      <div className="row" key={local.id}>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <FormControl>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Localização da Carga (Cidade)"
                              size="small"
                              inputProps={{ readOnly: true }}
                              InputLabelProps={{ shrink: true }}
                              value={local.cidade}
                            />
                          </FormControl>
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <FormControl>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Localização da Carga (UF)"
                              size="small"
                              inputProps={{ readOnly: true }}
                              InputLabelProps={{ shrink: true }}
                              value={local.estado}
                            />
                          </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                          <FormControl>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Quantidade (caixas)"
                              size="small"
                              inputProps={{ readOnly: true }}
                              value={local.quantidade}
                            />
                          </FormControl>
                        </div>
                      </div>
                    )
                  )}

              

                <div className="row">

                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Pedido Mínimo (Caixas)"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={values?.detalheLoteDto[position]?.pedidoMinimo}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row">
         

                </div>

                <div className="row">
                  <div className="col-sm-5 col-md-5 col-lg-5">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Diferença – Preço de varejo x Preço unitário"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={handleConvertToCurrencyText(
                          values?.detalheLoteDto[position]?.valorEconomia
                        )}
                      />
                    </FormControl>
                  </div>

                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Markup – Preço unitário x Preço varejo"
                        size="small"
                        inputProps={{ readOnly: true }}
                        value={`${
                          values?.detalheLoteDto[position]?.markup || 0
                        }%`}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 mt10">
                    <InputLabel>Link da Oportunidade (Buyer)</InputLabel>
                    <Typography variant="caption">
                      {values?.linkOportunidade && (
                        <a
                          href={
                            `/pedido/${values?.id}`
                          }
                        >
                          {`/pedido/${values?.id}`}
                        </a>
                      )}
                    </Typography>
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <button
                    className="mt20 buton-white-black-border"
                    style={{ width: "291px" }}
                    onClick={handleCloseModal}
                  >
                    VOLTAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        {/* </Fade> */}
      </div>
    </Modal>
  );
}

export default ResumoOportunidade;
